import { SimpleDialog } from "@powerdiary/components-library/lib";
import { useClientPortalSelector } from "../../../redux";
import { StripeProvider, useInitializeStripe } from "../../Shared/Stripe";
import LoadingOverlay from "../../Shared/LoadingOverlay";
import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";
import InvoicesStripePayment from "../InvoicesStripePayment";
import { useAnalytics } from "../../../hooks/useAnalytics";
import { useEffect } from "react";

interface IInvoiceStripePayModalProps {
    handleClose: () => void;
}

export default function InvoiceStripePayModal({ handleClose }: Readonly<IInvoiceStripePayModalProps>) {
    const { invoiceStripePayment } = useClientPortalSelector((state) => state.invoice);
    const { clientPortalConfig } = useClientPortalConfigContext();
    const { track } = useAnalytics();
    const { stripe, loading: stripeLoading } = useInitializeStripe({
        stripeKey: clientPortalConfig.stripeKey,
        practitionerStripeAccountId: invoiceStripePayment.practitionerStripeAccountId,
    });

    useEffect(() => {
        track("invoice_payment_form_opened", {
            invoice_count: invoiceStripePayment.invoiceIds?.length || 0,
            amount: invoiceStripePayment.amount,
        });
    }, [track, invoiceStripePayment]);

    if (stripeLoading) {
        return <LoadingOverlay />;
    }

    return (
        <SimpleDialog
            open
            handleClose={handleClose}
            dialogTitleText="Credit card payment"
            dataTestIdSuffix="stripe_pay"
            renderContent={() => (
                <StripeProvider stripe={stripe}>
                    <InvoicesStripePayment />
                </StripeProvider>
            )}
        ></SimpleDialog>
    );
}
